<template>
  <NewGlassCard class="card-without-title default-mb" title="">
    <div class="header_container">
      <v-btn class="back-button" @click="$emit('go-back')">
        <v-icon color="#6E6E6E">mdi-arrow-left</v-icon>
      </v-btn>
      <div class="item_container">
        <div v-html="applicantHtml" class="company_data"></div>
        <div v-html="addressHtml" class="company_address"></div>
      </div>
      <v-btn
        rounded
        :style="{
          color:
            selectedConsumptionDevicesOrder.status !==
            CONSUMPTION_DEVICES_STATUSES.cancelled.value
              ? 'white'
              : 'black',
        }"
        class="ml-10 confirm-order-button"
        :color="statusConfig[1]"
      >
        {{ statusConfig[0] }}
      </v-btn>
      <div class="start-exam-button" v-if="showCancelButton">
        <v-btn class="cancel_btn" @click="$emit('cancel-order')">
          <span style="font-weight: 700">
            {{ $t('feed_in_system_details.cancel_order') }}
          </span>
        </v-btn>
      </div>
      <div
        style="width: 40%; justify-content: flex-end; display: flex"
        v-if="showStartTechnicalInspection"
      >
        <v-btn class="mr-4" @click="$emit('start-inspection')" color="primary">
          {{ $t('consumption_devices.order_details.start_inspection') }}
        </v-btn>
      </div>
    </div>
  </NewGlassCard>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import { CONSUMPTION_DEVICES_STATUSES } from '../../helpers/constants';

export default {
  name: 'ConsumptionDevicesHeaderDetail',
  components: {
    NewGlassCard,
  },
  props: {
    applicantHtml: String,
    addressHtml: String,
    statusConfig: Array,
  },
  data() {
    return {
      CONSUMPTION_DEVICES_STATUSES: CONSUMPTION_DEVICES_STATUSES,
      cancelOrderBlackList: [
        CONSUMPTION_DEVICES_STATUSES.confirmed.value,
        CONSUMPTION_DEVICES_STATUSES.transmitted.value,
        CONSUMPTION_DEVICES_STATUSES.cancelled.value,
        CONSUMPTION_DEVICES_STATUSES.declined.value,
      ],
    };
  },
  computed: {
    selectedConsumptionDevicesOrder() {
      return this.$store.getters.getSelectedConsumptionDevice;
    },
    showCancelButton() {
      return !this.cancelOrderBlackList.includes(
        this.selectedConsumptionDevicesOrder.status
      );
    },
    showStartTechnicalInspection() {
      return (
        this.selectedConsumptionDevicesOrder.status ===
        CONSUMPTION_DEVICES_STATUSES.inspection_ready.value
      );
    },
  },
  methods: {
    allDevicesReady(devices) {
      return Object.values(devices).every(
        (device) => device.ready_for_inspection === true
      );
    },
  },
};
</script>

<style scoped lang="scss">
.header_container {
  display: flex;
  align-items: center;
}
.item_container {
  display: flex;
  flex-direction: column;
  width: 40%;
}
.company_data {
  font-size: 25px;
}
.company_address {
  font-size: 20px;
}
.back-button {
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0;
  height: 35px !important;
  width: 90px;
  box-shadow: none;
  margin-right: 30px;
}
.confirm-order-button {
  box-shadow: none;
  pointer-events: none;
}
.start-exam-button {
  width: 40%;
  justify-content: flex-end;
  display: flex;
}
</style>
